import styled, { css } from "styled-components";

const MenuItemSingleStyled_active = css`
  background-color: #353a50;
  color: white;
  box-shadow: 0 4px 10px 0 rgba(53, 58, 80, 0.25);
`;

const MenuItemSingleStyled_unread = css`
  width: 8px;
  height: 8px;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(255, 191, 29, 0.5);
  background-color: #ffbf1d;
  content: "";
  position: absolute;
  right: 0;
  top: 0;
`;

export const MenuItemSingleStyled = styled.li`
  width: 100%;
  padding: 12px 24px;
  border-radius: 18px;
  height: 54px;

  font-weight: bold;
  margin-bottom: 11px;
  position: relative;
  font-size: 1.33333em;
  display: flex;

  transition: 0.2s;

  ${(props) => (props.active ? MenuItemSingleStyled_active : null)};

  &:hover {
    background-color: rgba(24, 24, 26, 0.1);
  }

  & > button:first-child {
    color: inherit;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .icon {
    margin-left: 11px;
    width: 18px;
    height: 18px;
  }

  .icon::after {
    ${(props) => {
      // console.log(props);
      return props.unread ? MenuItemSingleStyled_unread : null;
    }}
  }
`;
